import { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';

function usePopupHide() {
    const [cookies, setCookies, removeCookies] = useCookies(['hidePopupBanners']);
    const [isHide, setIsHide] = useState<boolean>(cookies.hidePopupBanners || false);
    const [isNone, setIsNone] = useState<boolean>(false);

    const hide = () => {
        setIsHide(true);
    };
    const hideToday = () => {
        if (cookies.hidePopupBanners) {
            removeCookies('hidePopupBanners');
        } else {
            setCookies('hidePopupBanners', 'true', { path: '/', maxAge: 60 * 60 * 24 });
        }
    };

    const isTodayHidden = !!cookies.hidePopupBanners;

    useEffect(() => {
        if (isHide) {
            const timeout = setTimeout(() => {
                setIsNone(true);
            }, 350);
            return () => clearTimeout(timeout);
        }
        return () => {};
    }, [isHide]);

    return {
        isHide, isNone, hideToday, hide, isTodayHidden,
    };
}

export default usePopupHide;
